"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PR = void 0;
exports.PR = {
    numericCode: '630',
    alpha2Code: 'PR',
    alpha3Code: 'PRI',
    englishName: {
        short: 'Puerto Rico',
        full: 'Puerto Rico',
    },
    names: {
        full: {
            en: 'Puerto Rico',
            fr: 'Porto Rico',
            es: 'Puerto Rico',
        },
        short: {
            en: 'Puerto Rico',
            fr: 'Porto Rico',
            es: 'Puerto Rico',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'es',
            languageAlpha3Code: 'spa',
            isAdministrative: true,
        },
    ],
    subdivisions: {},
    cities: [
        {
            name: 'Aguadilla',
            subdivision: 'Aguadilla',
        },
        {
            name: 'Arecibo',
            subdivision: 'Arecibo',
        },
        {
            name: 'Barceloneta',
            subdivision: 'Barceloneta',
        },
        {
            name: 'Bayamón',
            subdivision: 'Bayamón',
        },
        {
            name: 'Caguas',
            subdivision: 'Caguas',
        },
        {
            name: 'Candelaria',
            subdivision: 'Toa Baja',
        },
        {
            name: 'Carolina',
            subdivision: 'Carolina',
        },
        {
            name: 'Cataño',
            subdivision: 'Catano',
        },
        {
            name: 'Cayey',
            subdivision: 'Cayey',
        },
        {
            name: 'Fajardo',
            subdivision: 'Fajardo',
        },
        {
            name: 'Guayama',
            subdivision: 'Guayama',
        },
        {
            name: 'Guaynabo',
            subdivision: 'Guaynabo',
        },
        {
            name: 'Humacao',
            subdivision: 'Humacao',
        },
        {
            name: 'Levittown',
            subdivision: 'Toa Baja',
        },
        {
            name: 'Manatí',
            subdivision: 'Manati',
        },
        {
            name: 'Mayagüez',
            subdivision: 'Mayaguez',
        },
        {
            name: 'Ponce',
            subdivision: 'Ponce',
        },
        {
            name: 'San Juan',
            subdivision: 'San Juan',
        },
        {
            name: 'Trujillo Alto',
            subdivision: 'Trujillo Alto',
        },
        {
            name: 'Vega Baja',
            subdivision: 'Vega Baja',
        },
        {
            name: 'Yauco',
            subdivision: 'Yauco',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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